import { Text } from '@mnd-frontend/ui/publish/components';

const RelatedContent = () => (
  <>
    <Text as="h3" variant="headlineSmall">
      Related content
    </Text>
    <Text as="p" variant="body">
      Related content allows you to build connections among stories in your newsroom. Each content
      piece is displayed at the bottom of each story, and lets your audience read more about
      subjects that already interest them.
    </Text>
    <Text as="h4" variant="labelMedium" marginTop="SPACING_3">
      Keep it relevant
    </Text>
    <Text as="p" variant="body">
      Always keep your related content relevant to your audience. If your story is about the launch
      of your new flagship store, you could add an interview with the new store manager as a related
      content piece.
    </Text>
  </>
);

export default RelatedContent;
